import ApplicationWizard from './ApplicationWizard';

const CreateApplicationPage = () => {
  return <ApplicationWizard mode="create" />;
};

export default CreateApplicationPage;
